import { useState } from "react";
import { Award, X, ZoomIn } from "lucide-react";

const Certifications = () => {
  const [selectedCert, setSelectedCert] = useState(null);

  const certificates = [
    {
      title: "AI Fundamentals",
      issuer: "Google via Coursera",
      date: "April 2026",
      image: "/images/certificates/ai-fundamentals.png"
    },
    {
      title: "Introduction to Digital Marketing",
      issuer: "Great Learning",
      date: "April 2026",
      image: "/images/certificates/digital-marketing.jpg"
    },
    {
      title: "Artificial Intelligence Mastery",
      issuer: "Beep Learning",
      date: "June 2026",
      image: "/images/certificates/beep-ai-mastery.jpg"
    }
  ];

  return (
    <section id="certificates" className="py-14 md:py-20 px-4 bg-white" data-testid="certifications-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-xs font-black tracking-widest mb-4">
            <Award size={14} />
            CERTIFICATIONS
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-black mb-3">
            Our <span className="text-red-600">Certifications</span>
          </h2>
          <p className="text-gray-500 text-lg">Verified expertise in AI, Digital Marketing & E-commerce</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {certificates.map((cert, idx) => (
            <div
              key={idx}
              className="group relative bg-white rounded-2xl border-2 border-gray-100 overflow-hidden hover:border-red-500 hover:shadow-[0_20px_60px_-15px_rgba(220,38,38,0.15)] transition-all duration-500 hover:-translate-y-2 cursor-pointer"
              onClick={() => setSelectedCert(cert)}
              data-testid={`certificate-${idx}`}
            >
              {/* Certificate Image */}
              <div className="relative aspect-[4/3] overflow-hidden bg-gray-50">
                <img
                  src={cert.image}
                  alt={`${cert.title} Certificate - BrandBorn`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-all duration-300 flex items-center justify-center">
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-white/90 rounded-full p-3">
                    <ZoomIn size={20} className="text-black" />
                  </div>
                </div>
              </div>
              
              {/* Info */}
              <div className="p-5">
                <h3 className="text-base font-black text-black mb-1">{cert.title}</h3>
                <p className="text-gray-500 text-sm">{cert.issuer}</p>
                <p className="text-gray-400 text-xs mt-1">{cert.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedCert && (
        <div
          className="fixed inset-0 z-[200] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setSelectedCert(null)}
        >
          <button
            onClick={() => setSelectedCert(null)}
            className="absolute top-6 right-6 text-white/70 hover:text-white bg-white/10 rounded-full p-2 transition-all"
          >
            <X size={24} />
          </button>
          <img
            src={selectedCert.image}
            alt={selectedCert.title}
            className="max-w-full max-h-[85vh] object-contain rounded-xl shadow-2xl"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </section>
  );
};

export default Certifications;
